import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type EmailValidationMessages = SidebarMessages & {
  verifyEmailTitle: string;
  verifyEmailSubtitle: string;
  verifyEmailDescription: string;
  resendVerificationEmail: string;
  wrongEmailAddress: string;
  returnToRegistration: string;
};
export const EMAIL_VALIDATION_MESSAGES: EmailValidationMessages = {
  verifyEmailTitle: "Verifique seu email",
  verifyEmailSubtitle: "Nós enviamos um link de verificação para:",
  verifyEmailDescription:
    "Verifique seu e-mail ou clique no link de verificação para continuar criando sua conta.",
  resendVerificationEmail: "Reenviar e-mail de verificação",
  wrongEmailAddress: "Endereço de e-mail errado?",
  returnToRegistration: "Voltar para inscrição",

  ...SIDEBAR_MESSAGES,
};

export default EMAIL_VALIDATION_MESSAGES;
